import './ToolBar.less'
import ToolBar from './ToolBar'
export default ToolBar